/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_Rest_Week_DoneInputs */

const en_us2_recovery_rest_week_done = /** @type {(inputs: Recovery_Rest_Week_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've done this week's workouts. Resting now is part of the plan.`)
};

const pt_br2_recovery_rest_week_done = /** @type {(inputs: Recovery_Rest_Week_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você já fez os treinos da semana. Descansar agora faz parte do plano.`)
};

const es_419_recovery_rest_week_done = /** @type {(inputs: Recovery_Rest_Week_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya hiciste los entrenamientos de la semana. Descansar ahora es parte del plan.`)
};

const pt_pt2_recovery_rest_week_done = /** @type {(inputs: Recovery_Rest_Week_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já fizeste os treinos da semana. Descansar agora faz parte do plano.`)
};

const fr_fr2_recovery_rest_week_done = /** @type {(inputs: Recovery_Rest_Week_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as fait les séances de la semaine. Te reposer maintenant fait partie du programme.`)
};

const de_de2_recovery_rest_week_done = /** @type {(inputs: Recovery_Rest_Week_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast die Trainings dieser Woche geschafft. Jetzt zu ruhen gehört zum Plan.`)
};

const it_it2_recovery_rest_week_done = /** @type {(inputs: Recovery_Rest_Week_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai fatto gli allenamenti di questa settimana. Riposare ora fa parte della scheda.`)
};

/**
* | output |
* | --- |
* | "You've done this week's workouts. Resting now is part of the plan." |
*
* @param {Recovery_Rest_Week_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_rest_week_done = /** @type {((inputs?: Recovery_Rest_Week_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_Rest_Week_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_rest_week_done(inputs)
	if (locale === "es-419") return es_419_recovery_rest_week_done(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_rest_week_done(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_rest_week_done(inputs)
	if (locale === "de-DE") return de_de2_recovery_rest_week_done(inputs)
	if (locale === "it-IT") return it_it2_recovery_rest_week_done(inputs)
	return en_us2_recovery_rest_week_done(inputs)
});
export { recovery_rest_week_done as "recovery.rest_week_done" }